import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getLocalStorageAuth } from '../actions';

let logoutTimer;

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  login: (token) => {},
  logout: () => {},
});

const calculateRemaningTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();

  const remainingDuration = adjExpirationTime - currentTime;

  return remainingDuration;
};

const retrieveStoredToken = () => {
  const storedAuth = localStorage.getItem('auth');

  if (storedAuth) {
    return JSON.parse(storedAuth).token;
  } else {
    return null;
  }
};

export const AuthProvider = (props) => {
  const dispatch = useDispatch();
  const tokenData = retrieveStoredToken();

  let initialToken;
  if (tokenData) {
    initialToken = tokenData;
  }

  // console.log('tokenData', tokenData);

  const [token, setToken] = useState(initialToken);

  useEffect(() => {
    dispatch(getLocalStorageAuth());
  }, [dispatch, token]);

  const userIsLoggedIn = !!tokenData;

  const loginHandler = (data) =>
    new Promise((resolve, reject) => {
      try {
        setToken(data.token);
        localStorage.setItem('auth', JSON.stringify(data));
        resolve();
      } catch (e) {
        reject(e);
      }
    });

  const logoutHandler = useCallback(() => {
    setToken(null);
    localStorage.removeItem('auth');
  }, []);

  const contextValue = {
    token: tokenData,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
